export default __webpack_public_path__ + "static/media/3left.561e2ec1.png";